import { Divider, Typography, Grid, Tab } from "@material-ui/core";
import React, { Component } from "react";
import { connect } from "react-redux";
import { getDecks, updateHeaderInfo, logout, updateUserProfile, getUserDetails, submitCME, getSASPResidencyProgram, sendSASPResidentAccess } from "../actions";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Link, Redirect } from "react-router-dom";
import { CopyrightWidget, LoadingCard } from "../components";
import { deviceData, setContainer, getThisYear } from "../common";
import { isBrowser, } from 'react-device-detect';

import "../styles/deckCreationStyles.css";
import "../styles/masterStyles.css";

class Program extends Component {
    state = {
        loading: true,
        program: null,
        decks: []
    }

    componentDidMount = async () => {
        await this.props.updateHeaderInfo({
            route:"/program", 
            name: "Program", 
            iconTwo: 'menu', 
            iconOne: 'home',
            color: "#00567a"
        });

        const { mcid, key } = this.props.auth_feedback;
        const tracking = deviceData(this.props.location, 'navigate');

        let bool = true;

        if (typeof this.props.program === 'undefined' || this.props.program === null) {
            bool = false;
            await this.props.getSASPResidencyProgram({ mcid: mcid, key: key });

            return this.setState({
                ...this.state,
                tracking: tracking,
                loading: bool
            })
        } else {
            return this.setState({
                ...this.state,
                tracking: tracking,
                loading: bool,
                program: this.props.program
            })
        }        
    };

    componentDidUpdate = async (prevProps, prevState) => {
        if (prevProps.program !== this.props.program) {
            return this.setState({
                ...this.state,
                program: this.props.program
            })
        }

        if (prevState.program !== this.state.program) {
            if (typeof this.state.program === 'undefined') {
                return this.setState({
                    ...this.state,
                    laoding: true,
                })
            }

            return this.setState({
                ...this.state,
                loading: false,
            })
        }
    }

    handleAccess = (obj) => {
        if (obj.data.accesslevel === 2) {
            return <Redirect to={obj} />
        } else {
            this.setState({
                ...this.state,
                loading: true,
            })

            this.props.sendSASPResidentAccess(obj.data);
        }

        return null;
    }

    render () {
        if (this.state.loading) {
            return (
                <LoadingCard text="Loading Program Data..."/>
            )
        } else {
            return (
                <>
                    <div style={setContainer(isBrowser)}>
                        <Typography className="homeDividerText">{this.state.program}</Typography>

                        <div className="margin-bottom-16">
                            <Grid item xs={12} className="">
                                <TableContainer component={Paper}>
                                    <Table style={{width: "100%"}} aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>
                                                    Resident
                                                </TableCell>

                                                <TableCell align="center">Access Permissions</TableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {this.state.program.residents.map((item, index) => {
                                                let target = {
                                                    pathname: 'resident',
                                                    data: {
                                                        programid: this.state.program.programid,
                                                        residentid: item.residentid,
                                                        mcid: this.props.user_details.mcid,
                                                        key: this.props.user_details.key,
                                                        accesslevel: item.accesslevel,
                                                        pathname: 'resident'
                                                    } 
                                                }

                                                return (
                                                    <TableRow key={`Resident-${index}`}>
                                                        <TableCell>
                                                            <Link onClick={() => {
                                                                return this.handleAccess(target);
                                                            }}>
                                                                {item.displayName}
                                                            </Link>    
                                                        </TableCell>

                                                        <TableCell align="center">
                                                            {item.accessLevel !== -1
                                                                ? (
                                                                    <>
                                                                        <Link onClick={() => {
                                                                            return this.handleAccess(target);
                                                                        }}>
                                                                            {item.accessleveltext}
                                                                        </Link>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <Link onClick={() => {
                                                                            return this.handleAccess(target);
                                                                        }}>
                                                                            {item.accessleveltext}
                                                                        </Link>
                                                                    </>
                                                                )
                                                            }
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                            })}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                        </div>

                        <CopyrightWidget 
                            style={{width: "auto;"}}
                            year={getThisYear()}
                            textAlign={'center'}
                            className="margin-top-32 padding-top-8 padding-bottom-24 padding-left-16 padding-right-16"
                        />
                    </div>
                </>
            );
        }
        
    }
}

const mapStateToProps = state => {
    const { auth_feedback, user_details, program } = state.auth;
    const { headerText, iconOne, iconTwo } = state.style;
    const { deckList } = state.decks;
    return {
        headerText,
        iconOne,
        iconTwo,
        deckList,
        auth_feedback,
        user_details,
        program
    };
};

const ProgramScreen = connect(mapStateToProps, { 
    updateHeaderInfo, getDecks, logout, updateUserProfile, getUserDetails, submitCME, getSASPResidencyProgram, sendSASPResidentAccess
})(
    Program
);

export { ProgramScreen };
